import { render, staticRenderFns } from "./IconLocation.vue?vue&type=template&id=2adf83dc"
import script from "./IconLocation.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconLocation.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports